<!-- <video id="id-of-video-element"  muted></video> -->
	<div class="btns w-100 auction-stream">
		<video id="localVideo"  #localVideo  [muted]="true" [controls]="false"></video>
		<button id="publishBtn" *ngIf="!showStream" class="btnLight_fill" (click)="initWebrtc()">{{"Auctions.Start stream"|translate}}</button>
		<button id="publishBtn" *ngIf="!closeStream && showStream"  class="btnLight_fill" (click)="PublishStreaming()">{{"Auctions.Publish Now"|translate}}</button>
		<button id="publishBtn" *ngIf="showStream && closeStream"  class="btnLight_fill" (click)="StopPublishing()">{{"Auctions.Stop stream"|translate}}</button>
	</div>
	<!-- <button id="stopPublishBtn" class="btn btn-primary mt-4 p-4 text-center ml-2" (click)="StopPublishing()" >Stop Publish</button> -->
